/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WallItemARElementArrowFromJSON, WallItemARElementArrowToJSON, WallItemARElementMeasurementFromJSON, WallItemARElementMeasurementToJSON, WallItemARElementModel3dFromJSON, WallItemARElementModel3dToJSON, WallItemARElementTextFromJSON, WallItemARElementTextToJSON, } from './';
export function WallItemARElementFromJSON(json) {
    return WallItemARElementFromJSONTyped(json, false);
}
export function WallItemARElementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'arrow': !exists(json, 'arrow') ? undefined : WallItemARElementArrowFromJSON(json['arrow']),
        'measurement': !exists(json, 'measurement') ? undefined : WallItemARElementMeasurementFromJSON(json['measurement']),
        'text': !exists(json, 'text') ? undefined : WallItemARElementTextFromJSON(json['text']),
        'model3d': !exists(json, 'model3d') ? undefined : WallItemARElementModel3dFromJSON(json['model3d']),
    };
}
export function WallItemARElementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'arrow': WallItemARElementArrowToJSON(value.arrow),
        'measurement': WallItemARElementMeasurementToJSON(value.measurement),
        'text': WallItemARElementTextToJSON(value.text),
        'model3d': WallItemARElementModel3dToJSON(value.model3d),
    };
}
//# sourceMappingURL=WallItemARElement.js.map